import React from 'react';
import { connect } from 'react-redux';
import md5 from 'md5';
import { APIHOST } from '../../../config/';
import { login, createIsAuthenticatedAction } from './actions';
import { Icon, Button, Spin, Input, Form, Row, Col, message } from 'antd';
const FormItem = Form.Item;
import Urls from '../../../config/index';
import './style.scss';

const validateCode = Urls.LoginUrl.validateCode;

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            captchaImg: validateCode,
        };
    }

    changeCaptchaSrc = e => {
        let t = Math.random() * 100000;
        if (e) {
            e.target.setAttribute('src', this.state.captchaImg + parseInt(t, 10));
        }
    };

    handleSubmit = i => {
        i.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    await this.props.login(values.name, values.password, values.code);
                    window.location.href = '/statistics/task';
                } catch (err) {
                    console.log(err);
                    alert(err);
                }
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { login, userInfo } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        const formItemLayoutHalf = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        return (
            <div className="loginWrap" style={{ flex: 1}}>
                <div className="title">渠道运营管理</div>
                <Form onSubmit={this.handleSubmit} className="login-form">
                    <FormItem {...formItemLayout} label="用户名">
                        {getFieldDecorator('name', {
                            rules: [{ required: true, whitespace: true, message: '请输入用户名!' }],
                        })(
                            <Input
                                type="string"
                                prefix={<Icon type="user" style={{ fontSize: 13 }} />}
                                placeholder="请输入用户名"
                            />,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="密码">
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: '请输入密码!' }],
                        })(
                            <Input
                                htmlType="password"
                                prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                                type="password"
                                placeholder="请输入密码"
                            />,
                        )}
                    </FormItem>
                    <Row>
                        <Col span={18}>
                            <FormItem {...formItemLayoutHalf} label="验证码">
                                {getFieldDecorator('code', {
                                    initialValue: '',

                                    rules: [
                                        { required: true, whitespace: true, min: 4, max: 4, message: '请正确入4位验证码!' },
                                    ],
                                })(
                                    <Input
                                        className=""
                                        type="string"
                                        style={{ fontSize: 13, width: '95%', 'margin-left': '4px' }}
                                        placeholder="4位验证码"
                                    />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem>
                                {getFieldDecorator('img', {})(
                                    <img
                                        className=""
                                        alt="点击更换"
                                        title="点击更换验证码"
                                        id="captchaImg"
                                        style={{ float: 'right', cursor: 'pointer', height: '35px' }}
                                        src={this.state.captchaImg}
                                        onClick={e => {
                                            this.changeCaptchaSrc(e);
                                        }}
                                    />,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem style={{ 'text-align': 'center' }}>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            登录
                        </Button>
                    </FormItem>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userInfo: state.login.userInfo,
    isAuthenticated: state.login.isAuthenticated,
});

const mapDispatchToProps = dispatch => ({
    login: (name, password, code) => dispatch(login(name, password, code)),
    in: status => dispatch(createIsAuthenticatedAction(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Login));



// WEBPACK FOOTER //
// ./pages/login/index.js